/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jointhousandsofbusinessesgrowingwithpulsify6Inputs */

const en_jointhousandsofbusinessesgrowingwithpulsify6 = /** @type {(inputs: Jointhousandsofbusinessesgrowingwithpulsify6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join thousands of businesses growing with Pulsify`)
};

const de_jointhousandsofbusinessesgrowingwithpulsify6 = /** @type {(inputs: Jointhousandsofbusinessesgrowingwithpulsify6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mach mit bei den Unternehmen, die mit Pulsify wachsen.`)
};

/**
* | output |
* | --- |
* | "Join thousands of businesses growing with Pulsify" |
*
* @param {Jointhousandsofbusinessesgrowingwithpulsify6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const jointhousandsofbusinessesgrowingwithpulsify6 = /** @type {((inputs?: Jointhousandsofbusinessesgrowingwithpulsify6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jointhousandsofbusinessesgrowingwithpulsify6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jointhousandsofbusinessesgrowingwithpulsify6(inputs)
	return de_jointhousandsofbusinessesgrowingwithpulsify6(inputs)
});
export { jointhousandsofbusinessesgrowingwithpulsify6 as "joinThousandsOfBusinessesGrowingWithPulsify" }